// Import modules
import appState from './modules/appState'
// import basket from './modules/basket'
// import printerFilter from './modules/product-filter'
import serviceChecker from './modules/service-checker'

let storeConfig = {
  modules: {
    appState,
    // basket,
    // printerFilter,
    serviceChecker,
  },
}
export { storeConfig }
